import {
  DISPENSARY_TABS_US,
  CBD_STORE_TABS,
  DISPENSARY_TABS_CA,
  DOCTOR_TABS,
} from "./constants";

class LinkMaker {
  countryCode: string;
  isUSA: boolean;
  retailType: string;
  slug: string;

  constructor({
    slug,
    countryCode,
    retailType,
  }: {
    slug: string;
    countryCode: string;
    retailType: string | undefined | null;
  }) {
    this.slug = slug;
    this.countryCode = countryCode;
    this.isUSA = this.countryCode === "US";
    this.retailType = retailType || "dispensary";
  }

  getPagesFromCountryCode = () => {
    switch (this.retailType) {
      case "clinic":
        return DOCTOR_TABS;
      case "cbd-store":
        return CBD_STORE_TABS;
      case "dispensary":
        return this.isUSA ? DISPENSARY_TABS_US : DISPENSARY_TABS_CA;
      default:
        return this.isUSA ? DISPENSARY_TABS_US : DISPENSARY_TABS_CA;
    }
  };

  getAllTabsObjects = () => {
    if (!this.retailType) return [];
    const pageSettings = this.getPagesFromCountryCode();
    return Object.values(pageSettings).map(({ page, href }) => ({
      page,
      href,
      as: href.replace("[slug]", this.slug),
    }));
  };

  getRouteObject = (page: string) => {
    const pageSettings = this.getPagesFromCountryCode();
    const { href } = pageSettings[page] || pageSettings["dispensary"];
    return {
      href,
      as: href.replace("[slug]", this.slug),
    };
  };

  getMainTabRoute = () => {
    const pageSettings = this.getPagesFromCountryCode();
    const page = Object.keys(pageSettings)[0];
    return this.getRouteObject(page).as;
  };
}

export default LinkMaker;
